"use client";

import { cn } from "@/lib/utils";
import { useFallbackTrigger } from "./useFocusAfterFallback";
import { Glyph } from "./Glyph";
import { SELECT_TRIGGER_CLASS } from "./overlay.constants";
import { createLazyOverlay } from "./createLazyOverlay";
import type { SelectProps } from "./select.types";
import type { RefObject } from "react";
import type { FallbackTriggerState } from "./useFocusAfterFallback";
const LazySelectPanel = createLazyOverlay<SelectProps<string | number> & {
  fallbackRef?: RefObject<FallbackTriggerState>;
  fallbackHandlers: ReturnType<typeof useFallbackTrigger>["fallbackHandlers"];
}>({
  name: "select",
  load: () => import("./SelectPanel"),
  exportName: "SelectPanel",
  renderFallback: props => {
    const selectedLabel = props.options.find(option => option.value === props.value)?.label ?? "";
    return <span className={cn("inline-flex align-middle", props.className)}>
                <button type="button" {...props.fallbackHandlers} aria-label={selectedLabel ? `${props.label}: ${selectedLabel}` : props.label} disabled={props.disabled} className={cn(SELECT_TRIGGER_CLASS, props.triggerClassName)}>
                    <span className="whitespace-nowrap">{selectedLabel}</span>
                    <Glyph name="chevronDown" className="h-3.5 w-3.5 text-ink-3" />
                </button>
            </span>;
  }
});
export function Select<T extends string | number>(props: SelectProps<T>) {
  const {
    fallbackRef,
    fallbackHandlers
  } = useFallbackTrigger();
  return <LazySelectPanel {...props} fallbackRef={fallbackRef} fallbackHandlers={fallbackHandlers} onChange={next => {
    const option = props.options.find(candidate => candidate.value === next);
    if (option) props.onChange(option.value);
  }} data-sentry-element="LazySelectPanel" data-sentry-component="Select" data-sentry-source-file="Select.tsx" />;
}